import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import { footerWhiteBgVars } from './Footer.palette';

export const snapFooterPrimaryVars: MotifComponentProps<MotifComponent.FOOTER> = {
  ...footerWhiteBgVars,
  '--footer-bg-color': m('--neutral-v0'),
  '--footer-bar-bg-color': m('--neutral-v0'),
  '--footer-bar-header-desktop-font-text-transform': 'uppercase',
  '--footer-bar-header-mobile-font-text-transform': 'uppercase',
  '--footer-bar-header-font-weight': '600',
  '--footer-border-color': m('--neutral-v700'),
  '--footer-divider-border-color': m('--neutral-v700'),
  '--footer-bar-divider-border-color': m('--neutral-v700'),
} as const;
